// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"116":"cd312dc2","528":"2493ab96","832":"4f2fa5cc"}[chunkId] + ".chunk.js";
};